export const GET_ADJUSTMENT_FACTOR_LIST = '/land/get_adjustment_factor_list';
export const GET_SINGLE_ADJUSTMENT_FACTOR =
  '/land/get_single_adjustment_factor';
export const CREATE_ADJUSTMENT_FACTOR = '/land/create_adjustment_factor';
export const UPDATE_ADJUSTMENT_FACTOR = '/land/update_adjustment_factor';
export const REMOVE_ADJUSTMENT_FACTOR =
  '/land/remove_transaction_code_adjustment_factor';
export const GET_LAND_CLASSIFICATIONS_LIST = '/land/get_adjustment_factor';
export const GET_ORDINANCE_REVISION = 'rate/get_ordinance_revision_list';

export const FORM_DATA = {
  rptax_land_classification_id: '',
  assessment_level: '',
};
